















































import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { $t } from "@/lib/i18nHelpers";
import { FormFileUpload, PostAllowedFileType } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseInputFile from "@/components/BaseInputFile";
import CustomScroll from "@/components/CustomScroll";
import DragDropFiles from "@/components/DragDropFiles";
import FilePreview from "@/components/FilePreview";

export default defineComponent({
  name: "UploadFilesArea",
  components: { FilePreview, BaseButton, BaseInputFile, CustomScroll, DragDropFiles },
  props: {
    processing: { type: Boolean, default: false },
    fileList: { type: Array as PropType<FormFileUpload[]>, required: true },
    multiple: { type: Boolean, default: false },
    loadingUploadUrls: { type: Boolean, default: false },
    dragAndDropProhibited: { type: Boolean, default: false },
    fileTypes: { type: Array as PropType<PostAllowedFileType[]> },
    buttonText: { type: String as PropType<TranslateResult>, default: $t("Add files") },
    allowRemoveFiles: { type: Boolean, default: true },
  },
});
